export const EmailChanged = "EMAIL_STATE_CHANGED";
export const PasswordChanged = "PASSWORD_STATE_CHANGED";
export const StartAuth = "START_AUTHENTICATE";
export const AuthDone = "DONE_AUTHENTICATE";
export const AuthError = "ERROR_AUTHENTICATE";
export const AuthStateChanged = "AUTH_STATE";



// WEBPACK FOOTER //
// ./src/actions/types.ts